// extracted by mini-css-extract-plugin
module.exports = {"lds__roller":"styles_lds__roller__23Xn6"};